export default __webpack_public_path__ + "static/media/Searchbanner1.ea8eac66.jpg";